import Allium from './Allium';
import Etika from './Etika';
import Humm from './Humm';
import Novuna from './Novuna';
import Omni from './Omni';
import Propensio from './Propensio';

const Specific = {
  Allium,
  Etika,
  Humm,
  Novuna,
  Omni,
  Propensio,
};

export default Specific;
